// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amenity-checkbox-container[data-v-16776124]{cursor:pointer;display:flex;justify-content:center}.amenity-checkbox-container .amenity-checkbox[data-v-16776124]{padding-left:2rem !important;margin-bottom:0 !important}.amenity-checkbox-container[data-v-16776124] .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after{cursor:pointer !important}", ""]);
// Exports
module.exports = exports;
